export const environment = {
  mocketbnkPublicService: '/mocketbnk/api/public/aggregation',
};
